export class JsonHelper {
    /**
     *
     * @param json
     * If you’re aiming to inject payload into a <script>
     * within an HTML document, you need additional escaping per
     * https://mths.be/etago.
     *
     */
    static escapeJSON(json) {
        // this code is inspired by https://github.com/douglascrockford/JSON-js/blob/master/json2.js
        const escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
        // The following characters are reserved in JSON and must be properly escaped to be used in strings:
        const meta = {
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            '"': '\\"',
            '\\': '\\\\' // Backslash is replaced with \\\\
        };
        escapable.lastIndex = 0;
        return escapable.test(json)
            ? '"' +
                json.replace(escapable, a => {
                    const c = meta[a];
                    return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                }) +
                '"'
            : '"' + json + '"';
    }
}
//# sourceMappingURL=JsonHelper.js.map